module.exports = __webpack_public_path__ + "img/item_bookCover_08.e76d631d.jpeg";